import React, { useEffect, useState } from "react";

import PageContainer from "../components/shared/PageContainer";
import UsersTable from "../components/user/UsersTable";
import { ATPUser } from "../services/api";
import * as Objects from "../services/api/index";

const Users: React.FC = () => {
  const [users, setUsers] = useState<Objects.ATPUser[]>([]);

  const fetchUsers = () => {
    Objects.ATPUsers.list().then(setUsers);
  };

  useEffect(fetchUsers, []);

  const updateRole = (user: ATPUser) => user.update().then(fetchUsers);
  const deleteUser = (user: ATPUser) => user.delete().then(fetchUsers);

  return (
    <PageContainer>
      <UsersTable users={users} setUsers={setUsers} updateRole={updateRole} deleteUser={deleteUser} />
    </PageContainer>
  );
};

export default Users;
